import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="aep-swift" api="extension-version" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static var extensionVersion: String
`}</code></pre>
    <Variant platform="aep-objc" api="extension-version" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objective-c"
      }}>{`+ (nonnull NSString*) extensionVersion;
`}</code></pre>
    <Variant platform="acp-objc" api="extension-version" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objective-c"
      }}>{`+ (nonnull NSString*) extensionVersion;
`}</code></pre>
    <Variant platform="aep-swift" api="register-extension" repeat="2" mdxType="Variant" />
    <p>{`Registration occurs by passing `}<inlineCode parentName="p">{`CampaignClassic`}</inlineCode>{` to the `}<inlineCode parentName="p">{`MobileCore.registerExtensions`}</inlineCode>{` API.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`MobileCore.registerExtensions([CampaignClassic.self])
`}</code></pre>
    <Variant platform="aep-objc" api="register-extension" repeat="2" mdxType="Variant" />
    <p>{`Registration occurs by passing `}<inlineCode parentName="p">{`AEPMobileCampaignClassic`}</inlineCode>{` to the `}<inlineCode parentName="p">{`[AEPMobileCore registerExtensions:completion:]`}</inlineCode>{` API.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-objective-c"
      }}>{`[AEPMobileCore registerExtensions:@[AEPMobileCampaignClassic.class] completion:nil];
`}</code></pre>
    <Variant platform="acp-objc" api="register-extension" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objective-c"
      }}>{`[ACPCampaignClassic registerExtension];
[ACPCore start:^{
}];
`}</code></pre>
    <Variant platform="aep-swift" api="register-device" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func registerDevice(token: Data, userKey: String?, additionalParameters: [String: Any]?)
`}</code></pre>
    <Variant platform="aep-objc" api="register-device" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objective-c"
      }}>{`+ (void) registerDeviceWithToken: (nonnull NSData*) token userKey: (nullable NSString*) userKey additionalParams: (nullable NSDictionary*) additionalParams;
`}</code></pre>
    <Variant platform="acp-objc" api="register-device" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objective-c"
      }}>{`+ (void) registerDevice: (nonnull NSData*) token userKey: (nullable NSString*) userKey additionalParams: (nullable NSDictionary*) additionalParams callback: (nullable void (^) (BOOL success)) callback;
`}</code></pre>
    <Variant platform="aep-swift" api="track-notification-click" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func trackNotificationClick(withUserInfo userInfo: [AnyHashable: Any])
`}</code></pre>
    <Variant platform="aep-objc" api="track-notification-click" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objective-c"
      }}>{`+ (void) trackNotificationClickWithUserInfo:(nonnull NSDictionary*) userInfo;
`}</code></pre>
    <Variant platform="acp-objc" api="track-notification-click" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objective-c"
      }}>{`+ (void) trackNotificationClick:(nonnull NSDictionary<NSString*, NSString*>*) trackInfo;
`}</code></pre>
    <Variant platform="aep-swift" api="track-notification-receive" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func trackNotificationReceive(withUserInfo userInfo: [AnyHashable: Any])
`}</code></pre>
    <Variant platform="aep-objc" api="track-notification-receive" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objective-c"
      }}>{`+ (void) trackNotificationReceiveWithUserInfo:(nonnull NSDictionary*) userInfo;
`}</code></pre>
    <Variant platform="acp-objc" api="track-notification-receive" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objective-c"
      }}>{`+ (void) trackNotificationReceive:(nonnull NSDictionary<NSString*, NSString*>*) trackInfo;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      